// موجودة كلها في react-icons/lu
import * as LuIcons from 'react-icons/lu';
import { ReactComponent as HorseSvg } from '../assets/icons/horseicon.svg';
import { ReactComponent as HorseSvg2 } from '../assets/icons/horseicon2.svg';

const {
  LuHouse,
  LuLayoutDashboard,
  LuChartBar,
  LuBuilding,
  LuLayoutGrid,
  LuHotel,
  LuTruck,
  LuSettings,
  LuStethoscope,
  LuPawPrint,
  LuUsers,
  LuUser,
  LuClipboardList,
  LuFileText,
  LuPill,
  LuHammer,
  LuHeart,
  LuReceiptText,
  LuShieldCheck,
  LuHospital,
  LuGitBranch,
  LuNfc,
  LuBadgeCheck,
  LuBell,
  LuTrophy,
  LuLandmark,
} = LuIcons;

export const HorseIcon = ({ size = 20, ...rest }) => (
  <HorseSvg width={size} height={size} {...rest} />
);
export const HorseIcon2 = ({ size = 20, ...rest }) => (
  <HorseSvg2 width={size} height={size} {...rest} />
);

const POPULAR_LUCIDE_ICONS = [
  'LuActivity',
  'LuAirVent',
  'LuAlarmClock',
  'LuAmbulance',
  'LuArchive',
  'LuArchiveRestore',
  'LuArrowDown',
  'LuArrowDownUp',
  'LuArrowLeft',
  'LuArrowLeftRight',
  'LuArrowRight',
  'LuArrowRightLeft',
  'LuArrowUp',
  'LuAward',
  'LuBadgeAlert',
  'LuBadgeCheck',
  'LuBadgeDollarSign',
  'LuBadgeInfo',
  'LuBadgePlus',
  'LuBanknote',
  'LuBarcode',
  'LuBath',
  'LuBattery',
  'LuBed',
  'LuBedDouble',
  'LuBell',
  'LuBellRing',
  'LuBike',
  'LuBook',
  'LuBookCheck',
  'LuBookOpen',
  'LuBookOpenCheck',
  'LuBookText',
  'LuBookmark',
  'LuBox',
  'LuBoxes',
  'LuBrain',
  'LuBriefcase',
  'LuBriefcaseBusiness',
  'LuBriefcaseMedical',
  'LuBuilding',
  'LuBuilding2',
  'LuBus',
  'LuBusFront',
  'LuCalculator',
  'LuCalendar',
  'LuCalendarCheck',
  'LuCalendarClock',
  'LuCalendarDays',
  'LuCamera',
  'LuCar',
  'LuChartBar',
  'LuChartColumn',
  'LuChartLine',
  'LuChartNoAxesCombined',
  'LuChartPie',
  'LuCheck',
  'LuCheckCheck',
  'LuCircleCheck',
  'LuCircleDollarSign',
  'LuCircleHelp',
  'LuCirclePlus',
  'LuCircleUser',
  'LuClipboard',
  'LuClipboardCheck',
  'LuClipboardList',
  'LuClipboardPen',
  'LuClock',
  'LuCloud',
  'LuCog',
  'LuCoins',
  'LuContact',
  'LuCreditCard',
  'LuDatabase',
  'LuDoorClosed',
  'LuDoorOpen',
  'LuDownload',
  'LuDumbbell',
  'LuEarth',
  'LuSquarePen',
  'LuEllipsis',
  'LuEye',
  'LuEyeOff',
  'LuFile',
  'LuFileCheck',
  'LuFileClock',
  'LuFileDown',
  'LuFilePen',
  'LuFilePlus',
  'LuFileText',
  'LuFileUp',
  'LuFilter',
  'LuFolder',
  'LuFolderOpen',
  'LuGauge',
  'LuGitBranch',
  'LuGlobe',
  'LuGraduationCap',
  'LuHammer',
  'LuHandCoins',
  'LuHandshake',
  'LuHardDrive',
  'LuHeadphones',
  'LuHeart',
  'LuHeartPulse',
  'LuHistory',
  'LuHouse',
  'LuHospital',
  'LuHotel',
  'LuHouse',
  'LuIdCard',
  'LuImage',
  'LuInbox',
  'LuInfo',
  'LuKey',
  'LuLandmark',
  'LuLanguages',
  'LuLayoutDashboard',
  'LuLayoutGrid',
  'LuList',
  'LuListChecks',
  'LuListFilter',
  'LuLock',
  'LuLogIn',
  'LuLogOut',
  'LuMail',
  'LuMap',
  'LuMapPin',
  'LuMedal',
  'LuMegaphone',
  'LuMessageCircle',
  'LuMessageSquare',
  'LuMonitor',
  'LuMoon',
  'LuNotebook',
  'LuNotebookTabs',
  'LuPackage',
  'LuPanelLeft',
  'LuPaperclip',
  'LuPawPrint',
  'LuPen',
  'LuPenLine',
  'LuPencil',
  'LuPhone',
  'LuPill',
  'LuPlus',
  'LuPrinter',
  'LuQrCode',
  'LuRefreshCcw',
  'LuReceipt',
  'LuReceiptText',
  'LuRotateCcw',
  'LuRoute',
  'LuSave',
  'LuScale',
  'LuScanLine',
  'LuSearch',
  'LuSend',
  'LuSettings',
  'LuShield',
  'LuShieldCheck',
  'LuShoppingCart',
  'LuSiren',
  'LuSparkles',
  'LuSquarePen',
  'LuStar',
  'LuStethoscope',
  'LuTable',
  'LuTag',
  'LuTags',
  'LuTarget',
  'LuTimer',
  'LuTrash',
  'LuTrendingDown',
  'LuTrendingUp',
  'LuTruck',
  'LuTrophy',
  'LuUpload',
  'LuUser',
  'LuUserCheck',
  'LuUserCog',
  'LuUserPlus',
  'LuUsers',
  'LuWallet',
  'LuWalletCards',
  'LuWarehouse',
  'LuWrench',
  'LuX',
];

const iconKeyFromComponentName = (name) =>
  name
    .replace(/^Lu/, '')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .toLowerCase();

const POPULAR_ICON_MAP = Object.fromEntries(
  POPULAR_LUCIDE_ICONS
    .map((name) => [iconKeyFromComponentName(name), LuIcons[name]])
    .filter(([, Icon]) => Boolean(Icon))
);

export const ICON_MAP = {
  ...POPULAR_ICON_MAP,
  // الأساسيات
  home: LuHouse,
  dashboard: LuLayoutDashboard,
  statistics: LuChartBar,
  settings: LuSettings,
  checkup2: LuBadgeCheck,
  // الخيل / الملاك
  horses: HorseIcon, // <— replaced here
  'horse-details': HorseIcon2,
  competitions: LuTrophy,

  owners: LuUsers,
  'owner-details': LuUser,

  // الإسطبلات والسكن
  'stable-list': LuBuilding,
  'stable-rooms': LuLayoutGrid,
  accommodations: LuHotel,
  'available-rooms': LuBuilding,

  // العيادة والفحوصات
  checkup: LuStethoscope,
  'vet-clinic': LuHospital,
  'checkup-types': LuClipboardList,
  medications: LuPill,
  procedures: LuClipboardList,
  'record-list': LuFileText,

  // حدّاد / توليد / أخرى
  farrier: LuHammer,
  reproduction: LuHeart,
  pedigree: LuGitBranch,

  // نقل / محاسبة / عملاء / صلاحيات / NFC / تنبيهات
  HorseTransportReportPage: LuTruck,
  accountant: LuReceiptText,
  finance: LuLandmark,
  financesummary: LuLandmark,
  'finance-summary': LuLandmark,
  horsefinancecenter: LuLandmark,
  HorseFinanceCenter: LuLandmark,
  clients: LuUsers,
  'roles-permissions': LuShieldCheck,
  'role-permissions': LuShieldCheck,
  'user-permissions': LuShieldCheck,
  'access-control': LuShieldCheck,
  backup: LuIcons.LuDatabase,
  'settings/backups': LuIcons.LuDatabase,
  nfc: LuNfc,
  alerts: LuBell,

  // افتراضي
  default: LuPawPrint,
};

export function resolveSidebarIconKey(itemOrKey) {
  if (typeof itemOrKey === 'string') return itemOrKey;
  const hint = [
    itemOrKey?.path,
    itemOrKey?.permission_key,
    itemOrKey?.text_key,
    itemOrKey?.icon_key,
  ]
    .filter(Boolean)
    .join('|')
    .toLowerCase();

  if (hint.includes('finance')) return 'finance';
  return itemOrKey?.icon_key || itemOrKey?.permission_key || itemOrKey?.text_key;
}

// ترجيع كومبوننت الأيقونة
export function getSidebarIcon(itemOrKey) {
  return ICON_MAP[resolveSidebarIconKey(itemOrKey)] || ICON_MAP.default;
}
